import { createFileRoute } from '@tanstack/react-router';

import { AppContentPage } from '@/features/app-content/AppContentPage';

/*
  One route per tab, which is what the sidebar's App content submenu links at, and one query
  behind all four: the page fetches its content together, so loading and failure stay the
  page's rather than becoming a tab's.
*/
export const Route = createFileRoute('/_app/app-content/messages')({
    component: () => <AppContentPage tab="messages" />,
});
